import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import css from './item.css'

export default class SelectListItem extends PureComponent {
    static propTypes = {
        label: PropTypes.string.isRequired,
        isActive: PropTypes.bool,
        isDark: PropTypes.bool,
        onClick: PropTypes.func,
        newPill: PropTypes.bool,
    }

    state = {
        isHovered: false,
    }

    onMouseOver() {
        this.setState({ isHovered: true })
    }

    onMouseOut() {
        this.setState({ isHovered: false })
    }

    render() {
        const { children, label, isActive, isDark, onClick, newPill } = this.props
        const { isHovered } = this.state
        const iconClass = isHovered ? (isActive ? css.removeIcon : css.addIcon) : isActive ? css.checkIcon : css.icon
        return (
            <div
                className={isActive ? css.itemActive : css.item}
                data-giphyisdark={isDark}
                onClick={() => onClick && onClick(label)}
                onMouseOut={() => this.onMouseOut()}
                onMouseOver={() => this.onMouseOver()}
            >
                {label}
                {newPill && <span className={css.newPill}>NEW</span>}
                {children || <i className={iconClass} data-giphyisdark={isDark} />}
            </div>
        )
    }
}
